import { useState } from 'react';
import KubitTooltip from '../../../components/KubitTooltip';
import {
  offset,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from '@floating-ui/react';
import { useCheckFeatureFunction } from '../../../utils/hooks';
import usePermission from '../../../utils/hooks/permissionHooks/usePermission';
import { useBootstrapSelector } from '../../../redux/selectorHooks';
import { assertNotNil } from '../../../utils/types';
import * as HeaderUI from '../HeaderUI';
import { dataManagementDropdownLinks } from '../utils';
import PermissionElementWrapper from '../../../pages/PermissionControls/PermissionElementWrapper';
import HeaderMenuItem from '../HeaderMenuItem';
import { SvgIcon } from '../../../components/Icon';
import { FloatingLayer } from '../../../components/FloatingManager';

const DataManagementDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { floatingStyles, refs, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [offset(5)],
    placement: 'bottom-end',
  });

  const click = useClick(context);
  const dismiss = useDismiss(context);
  const role = useRole(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
    role,
  ]);

  const { checkIsPermitted } = usePermission();
  const checkFeatureFunc = useCheckFeatureFunction();
  const permissionConfig = useBootstrapSelector('permissionConfig');
  assertNotNil(permissionConfig);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <KubitTooltip
        content="Data Management"
        placement="bottom"
        noOpenDelay={true}
      >
        <HeaderUI.IconContainer
          ref={refs.setReference}
          {...getReferenceProps()}
          $isActive={isOpen}
        >
          <SvgIcon
            name="database-gear"
            width={24}
            height={24}
            customFill="currentColor"
          />
        </HeaderUI.IconContainer>
      </KubitTooltip>
      {isOpen && (
        <FloatingLayer>
          <HeaderUI.Menu
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
          >
            {dataManagementDropdownLinks
              .filter((item) => {
                if (item?.requiredFeature) {
                  return checkFeatureFunc(item.requiredFeature);
                }
                return true;
              })
              .map((item) => {
                const isPermitted = item?.permissionKeys
                  ? checkIsPermitted({
                      requiredPermissionKeys: item.permissionKeys,
                      validateKind: 'OR',
                    })
                  : true;

                return (
                  <PermissionElementWrapper
                    key={item.icon}
                    isPermitted={isPermitted}
                  >
                    <HeaderMenuItem
                      to={item.to}
                      description={item.description}
                      icon={item.icon}
                      label={item.label}
                      onClick={handleClose}
                      disabled={!isPermitted}
                    />
                  </PermissionElementWrapper>
                );
              })}
          </HeaderUI.Menu>
        </FloatingLayer>
      )}
    </>
  );
};

export default DataManagementDropdown;
